import React, { useEffect } from 'react';
import {Col, Row} from 'reactstrap';
import {connect} from "react-redux";

// components
import XwitchLogList from "./_list";
import {showLoader} from "../../../components/loader/loader";

// actions
import { clearState, setApp, setViewMode } from "../../../redux/actions/generalActions/mainActions";
import { clearState as clearListState } from "../../../redux/actions/generalActions/listActions";
import { setForm } from "../../../redux/actions/generalActions/formActions";

function XwitchLog(props) {
    const { loading } = props.mainProps

    useEffect(() => {
        return () => {
            props.clearState();
            props.clearListState();
        }
    }, []);

    return (
        <div>
            {loading && showLoader()}
            <Row>
                <Col md="12">
                    <XwitchLogList />
                </Col>
            </Row>
        </div>
    );
}

const mapStateToProps = state => ({
    mainProps : state.mainProps
});

const mapActionsToProps = ({
    clearState,
    setForm,
    setApp,
    setViewMode,
    clearListState,
});

export default connect(mapStateToProps, mapActionsToProps)(XwitchLog)

